import { columnsheadId } from '../../universal/columnshead';
import WebUniversalNewEx, { WUExtendPropsType } from '../../system/WebUniversalNewEx';
import BuyerEdit from './BuyerEdit';
import { Button,Image, Tooltip } from 'antd';
import fetchApi from '../../../utils/api/fetchApi';
import system from '../../../config/systematic';
import { useEffect, useRef, useState } from 'react';
import antMessage from '../../../utils/extend/AntdNotification'
import BuyerProudct from './BuyerProudct';
import BuyerContact from './BuyerContact';

export default function Buyer(props: any) {
    const wmService = system.wmService;
    const ref = useRef<any>(undefined);
    const [buyerProudctModel, setBuyerProudctModel] = useState<boolean>(false);
    const [buyerContactModel, setBuyerContactModel] = useState<boolean>(false);

    const [buyerProudctData, setBuyerProudctData] = useState<any>()
    // 

    /** 刷新数据 */
    let initData: any;
    //表头
    const columnsHead = [
        {
            title: '专属id',
            dataIndex: 'selfId',
        },
        {
            title: '采购商电话',
            dataIndex: 'buyerPhone',
        },

        {
            title: '采购商',
            dataIndex: 'buyerName',

        },
        {
            title: '采购商类型',
            dataIndex: 'buyerType',
            render: (text: any) => (text ? text.buyerTypeName : "")

        },
        {
            title: '加密时长',
            dataIndex: 'buyerCodeTime',

        },
        {
            title: '采购商人员',
            // dataIndex: 'deptNameEx',
            render: (text: any, record: any) => {
                return <Button onClick={() => handleBuyerContact(record)} size={"small"} type="primary" >人员</Button>
            }
        },
        {
            title: '采购商产品',
            // dataIndex: 'deptNameEx',
            render: (text: any, record: any) => {
                return <Button onClick={() => handleBuyerProudct(record)} size={"small"} type="primary" >产品</Button>
            }
        },
        {
            title: '加密字符',
            dataIndex: 'buyerCode',
            render: (text: any, record: any) => (text ? <Tooltip placement="topLeft" title={text}>{
                (typeof text !== "undefined" && text !== null && !record.invalid) ?
                    (text.length >= 6 ? text.substring(0, 6) + '....' : text)
                    : <Button onClick={() => encryptionBuyer(record.id)} type="primary" size='small'>请重置</Button>
            }</Tooltip> : <Button onClick={() => encryptionBuyer(record.id)} type="primary" size='small'>加密</Button>)

        },
          {
            title: '营业执照',
            dataIndex: 'businessLicenseUrl',
            render: (text: any, record: any) => (
                < Image
                    src={text}
                    width={80}
                    height={80}
                    alt="图片" />
            )
        },

        // <Button onClick={()=>encryptionBuyer(record.id)} type="primary" size='small'>{}</Button>


    ];
      /**打开采购商产品 */
    const handleBuyerProudct = (record: any) => {
        
        setBuyerProudctData({
            buyerId:record.id,
        })
        setBuyerProudctModel(true)
    }
     const handleBuyerContact= (record: any) => {
        
        setBuyerProudctData({
            buyerId:record.id,
        })
        setBuyerContactModel(true)
    }
    
    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            // defaultService = ref.current.defaultService;
            // eslint-disable-next-line react-hooks/exhaustive-deps
            initData = ref.current.initData;
        }
        //同步获取数据 async - await
        // const fetchData = async () => {
        // }
        // fetchData();

        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //初始化数据
    const encryptionBuyer = (buyerId: string) => {
        fetchApi.POST(wmService, {
            apiId: "buyer",
            apiExtend: "encryptionBuyer",
            apiData: {
                buyerId
            }
        }).then((res) => {
            initData()
            antMessage('success', '加密/重置成功');

        }).catch((err) => {
            console.log("err", err);

            antMessage('error', '加密/重置失败', err.message);

        })

    }
    /**关闭采购商产品*/
    const closeBuyerProudct = (status: boolean) => {

        setBuyerProudctModel(false)
        if (status) {

        }
    }

      /**关闭采购商人员*/
    const closeBuyerContact = (status: boolean) => {

        setBuyerContactModel(false)
        if (status) {

        }
    }
    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '采购商',
        apiId: 'buyer',
        showStates: true,
        columns,
        pagination: true,
        EditComponent: BuyerEdit,
    };
    return (
        <>
            <WebUniversalNewEx ref={ref} props={extendProps}></WebUniversalNewEx>
            {buyerProudctModel ? (<BuyerProudct
                closeModal={closeBuyerProudct}
                data={buyerProudctData}
            ></BuyerProudct>) : null}

              {buyerContactModel ? (<BuyerContact
                closeModal={closeBuyerContact}
                data={buyerProudctData}
            ></BuyerContact>) : null}
        </>

    )
}
